import validateString from './validator';

/**
 * Returns true when the given param is NOT a valid non-empty string.
 * Used as an early-return guard, e.g. `if (notValid(siteId)) return;`.
 *
 * Re-introduced 2026-05-13 — this module existed historically (per the
 * git log "added notValid.js"), then was renamed to `validator.js` in a
 * later commit but the 4 siteConfig*.jsx callers were never updated.
 * Re-exporting the negation here keeps those imports working without
 * touching their files.
 *
 * @param {string} param
 * @returns {boolean}
 */
export default function notValid(param) {
  return !validateString(param);
}
